<form
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
    class="modal-wrapper">
    <div class="modal-header">
        <h2
            class="modal-title"
            id="exampleModalLabel">
            Link file
        </h2>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col">
                <label>File</label>
                <div
                    class="form-group required m-b-2"
                    [formGroup]="formGroup">
                    <div class="d-flex">
                        <div class="ng-autocomplete">
                            <ng-autocomplete
                                formControlName="file"
                                [data]="this.data | orderBy: 'title':false"
                                [searchKeyword]="'title'"
                                [itemTemplate]="itemTemplate"
                                autocomplete="off"
                                [notFoundTemplate]="notFoundTemplate">
                            </ng-autocomplete>

                            <ng-template
                                #itemTemplate
                                let-item>
                                <a [innerHTML]="item['title']"></a>
                            </ng-template>

                            <ng-template
                                #notFoundTemplate
                                let-notFound>
                                <div>No files found...</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button
            type="button"
            class="button button--outline"
            (click)="activeModal.close()">
            Close
        </button>
        <button
            type="submit"
            class="button button--primary">
            Link file
        </button>
    </div>
</form>
